import { ChangeDetectionStrategy, Component, Inject, inject, signal } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTooltipModule } from '@angular/material/tooltip'
import { LayerIntegrationUpdatePayload } from '@core/models/layers.model'
import { LayersClonedService } from '@core/services/layers-cloned.service'

@Component({
  selector: 'app-dialog-update-repository',
  templateUrl: './dialog-update-repository.component.html',
  styleUrl: './dialog-update-repository.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    // Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class DialogUpdateRepositoryComponent {
  readonly dialogRef = inject(MatDialogRef<DialogUpdateRepositoryComponent>)
  private readonly _layersClonedService = inject(LayersClonedService)

  isLoading$ = signal<boolean>(false)

  constructor(@Inject(MAT_DIALOG_DATA) public data: LayerIntegrationUpdatePayload) {}

  async updateRepo() {
    if (!this.data.repoName) {
      return
    }

    this.isLoading$.set(true)
    try {
      await this._layersClonedService.updateRepository(this.data.repoName)
      this.dialogRef.close(true)
    } finally {
      this.isLoading$.set(false)
    }
  }
}
